import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const EditQueueFeature = {
  // Roles that are eligible for the Edit Queue feature
  Roles: [
    MccsRoles.ADMINISTRATOR,
    MccsRoles.CREDENTIALING_ADMIN,
    MccsRoles.CREDENTIALING,
  ],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(EditQueueFeature.Roles, user),
} satisfies Feature
